// ignore-string-externalization

import React from 'react';
import {
  ButtonSecondary,
  ButtonPrimary,
  ButtonTertiary as ButtonTertiaryV5,
  NavBarListItem,
} from '@spotify-internal/encore-web-v5';
import {
  ButtonTertiary,
  ButtonSecondary as ButtonSecondaryV6,
  ButtonPrimary as ButtonPrimaryV6,
} from '@spotify-internal/encore-web-v6';
import { Link } from './Link';
import styled from 'styled-components';

type EncoreComponentProps<
  EncoreComponent extends React.ElementType,
  Component extends React.ElementType,
> = Omit<React.ComponentProps<EncoreComponent>, 'component'> &
  React.ComponentProps<Component>;

const StyledButtonPrimary = styled(ButtonPrimary)`
  &::after {
    border: 0;
  }
`;

export function ButtonPrimaryAsLink(
  props: EncoreComponentProps<typeof ButtonPrimary, typeof Link>,
) {
  return <StyledButtonPrimary {...props} component={Link} />;
}

export function ButtonSecondaryAsLink(
  props: EncoreComponentProps<typeof ButtonSecondary, typeof Link>,
) {
  return <ButtonSecondary {...props} component={Link} />;
}

export function ButtonPrimaryAsLinkV6(
  props: EncoreComponentProps<typeof ButtonPrimaryV6, typeof Link>,
) {
  return <ButtonPrimaryV6 {...props} component={Link} />;
}

export function ButtonSecondaryAsLinkV6(
  props: EncoreComponentProps<typeof ButtonSecondaryV6, typeof Link>,
) {
  return <ButtonSecondaryV6 {...props} component={Link} />;
}

export function ButtonTertiaryV5AsLink(
  props: EncoreComponentProps<typeof ButtonTertiaryV5, typeof Link>,
) {
  return <ButtonTertiaryV5 {...props} component={Link} />;
}

export function ButtonTertiaryAsLink(
  props: EncoreComponentProps<typeof ButtonTertiary, typeof Link>,
) {
  return <ButtonTertiary buttonSize="sm" {...props} component={Link} />;
}

export function NavBarListItemAsLink(
  props: EncoreComponentProps<typeof NavBarListItem, typeof Link>,
) {
  return <NavBarListItem {...props} component={Link} />;
}
